import { Gesture, gestureLayers } from "./BaseGesture"

class InstantMenuKeyboardShortcut extends Gesture {
  override layer = gestureLayers.keyboardShortcut

  override async onKeyDown(keyboard: KeyboardEvent) {
    const { state: instantState, closeInstantMenu, moveKeyboardSelectionCursor, keyboardSelectedFile, onSearch } = useInstantMenu()
    const { navigateToFile } = useNavigation()
    const { askAgentQuery } = useAgent()

    if (!instantState.value.visible)
      return

    else if (["Escape"].includes(keyboard.key)) {
      this.debug("Escape pressed, closing instant menu bar")
      keyboard.preventDefault()
      this.capture()
      closeInstantMenu()
    }

    else if (["ArrowUp"].includes(keyboard.key)) {
      moveKeyboardSelectionCursor("up")
    }

    else if (["ArrowDown"].includes(keyboard.key)) {
      moveKeyboardSelectionCursor("down")
    }

    else if (["Enter"].includes(keyboard.key) && this.shiftKeyModifier(keyboard)) {
      const query = instantState.value.query
      if (query.trim().length === 0)
        return this.warn("Shift + Enter pressed, but no query to ask agent")
      closeInstantMenu()
      await askAgentQuery(query)
    }

    else if (["Enter"].includes(keyboard.key)) {
      if (isDefined(keyboardSelectedFile)) {
        navigateToFile(keyboardSelectedFile.value)
        closeInstantMenu()
      }
      else
        onSearch()
    }
  }

  /**
   * TODO: address different OS'es, and test on Windows
   * @param keyboard event
   * @returns whether the OS-specific modifier key is pressed
   */
  commandKeyModifier(keyboard: KeyboardEvent) {
    return keyboard.metaKey || keyboard.ctrlKey
  }

  shiftKeyModifier(keyboard: KeyboardEvent) {
    return keyboard.shiftKey
  }
}

const instantMenuKeyboardShortcut = new InstantMenuKeyboardShortcut()
export default function () {
  return instantMenuKeyboardShortcut
}
